export const SUPPLIER_DISPLAYED_COLUMNS: string[] = [
  'supplierId',
  'supplierName',
  'supplierClassification',
  'city',
  'country',
  'groupKey',
  'groupKeyDescription',
  'vatNumber',
  'companyNumber',
  //'supplierConfirmed',
  'poVendor',
  'inactive',
  'blocked'
];
